import React from "react";
import "./index.css";
import HeroSection from "./SECTIONS/HERO";
import WhoAreWeSection from "./SECTIONS/SCREENING";
import ContactSection from "./SECTIONS/CONTACT";

const HomePage = () => {
  return (
    <>
      <div className="noise" />
      <div className="subsection">
      <WhoAreWeSection />
      {/* <HeroSection /> */}
      </div>
      
      <div className="subsection">
        {/* <WhoAreWeSection /> */}
        {/* <ContactSection /> */}
      </div>
    </>
  );
};

export default HomePage;
